<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <g style="opacity: 0"><rect x="0" y="0" width="16" height="16" rx="0" fill="#FFFFFF" fill-opacity="1" /></g>
      <g>
        <path
          d="M14.9997,9.09354C13.9563,9.8216,12.7186,10.21198,11.4537,10.21198C7.98974,10.21198,5.18164,7.35319,5.18164,3.82669C5.18164,2.8458,5.40326,1.879245,5.82984,0.999719231C2.94285,1.976938,1,4.71896,1,7.81626C1,11.7836,4.15911,14.9997,8.05608,14.9997C11.4666,14.9997,14.3933,12.5103,14.9997,9.09354Z"
          fill-rule="evenodd"
          fill="currentColor"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
